export const GET_LIST_TYPE_DOCUMENTS           = 'GET_LIST_TYPE_DOCUMENTS';
export const CHANGE_VALUE_INPUTS_FORM          = 'CHANGE_VALUE_INPUTS_FORM';
export const SELECTED_ITEMS_CATEGORIES         = 'SELECTED_ITEMS_CATEGORIES';
export const SAVE_TYPE_DOCUMENT                = 'SAVE_TYPE_DOCUMENT';
export const GET_ITEM_TYPE_DOCUMENT            = 'GET_ITEM_TYPE_DOCUMENT';
export const DELETE_ITEM_TYPE_DOCUMENT         = 'DELETE_ITEM_TYPE_DOCUMENT';
export const DISABLED_CATEGORY_RELATED         = 'DISABLED_CATEGORY_RELATED';
export const TYPE_DOCUMENTS_DEFAULT_DATA       = 'TYPE_DOCUMENTS_DEFAULT_DATA';
export const SELECTED_GENERAL_CONCEPTS         = 'SELECTED_GENERAL_CONCEPTS';
export const DISABLED_GENERAL_CONCEPT_RELATED  = 'DISABLED_GENERAL_CONCEPT_RELATED';
export const SELECTED_CONCEPT_DISCOUNT         = 'SELECTED_CONCEPT_DISCOUNT';
export const DISABLED_DISCOUNT_CONCEPT_RELATED = 'DISABLED_DISCOUNT_CONCEPT_RELATED';